import {
  CityOption,
  CountyOption,
  ProvinceOption,
} from "@/components/excel/schema/value/type/area";
import { AreaSharedCache } from "@/utils/AreaSharedCache";
import {
  DayOption,
  MonthOption,
  YearOption,
} from "@/components/excel/schema/value/type/date";
import {
  HourOption,
  MinuteOption,
  SecondOption,
} from "@/components/excel/schema/value/type/time";
import {
  CurrencyOption,
  SexOption,
} from "@/components/excel/schema/value/type/other";
import {
  daySource,
  hourSource,
  minuteSource,
  monthSource,
  secondSource,
  yearSource,
} from "@/components/excel/schema/selector/date-time";

export async function findSource(type: number) {
  if (type === ProvinceOption.value) {
    const list = await AreaSharedCache.loadChildren(0);
    if (list) {
      return list.map((it) => ({ value: it.id, text: it.name }));
    }
    return [];
  }
  if (type === CityOption.value || type === CountyOption.value) {
    return (await AreaSharedCache.loadChildren(0)) || [];
  }
  if (type === YearOption.value) {
    return yearSource;
  }
  if (type === MonthOption.value) {
    return monthSource;
  }
  if (type === DayOption.value) {
    return daySource;
  }
  if (type === HourOption.value) {
    return hourSource;
  }
  if (type === MinuteOption.value) {
    return minuteSource;
  }
  if (type === SecondOption.value) {
    return secondSource;
  }
  if (type === SexOption.value) {
    return SexOption.selector?.options ?? [];
  }
  if (type === CurrencyOption.value) {
    return CurrencyOption.selector?.options ?? [];
  }
  return [];
}